import React from "react";

function LeftArrowSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="16"
      fill="none"
      viewBox="0 0 26 16"
    >
      <path
        fill="#9CA3AF"
        fillRule="evenodd"
        d="M9.331 15.531a1.6 1.6 0 01-2.262 0l-6.4-6.4a1.6 1.6 0 010-2.262l6.4-6.4A1.6 1.6 0 019.33 2.73L5.662 6.4H24.2a1.6 1.6 0 110 3.2H5.662l3.669 3.669a1.6 1.6 0 010 2.262z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default LeftArrowSvg;
